// Module
var code = `<div class="row text-center"> <div class="col-12 col-lg-8 pt-5 mx-auto"> <div class="row text-center"> <div class="col-12"> <h2 class="error-text text-primary pb-3"></h2> <h1 class="secondary-text text-primary py-3"></h1> <div class="row error-contact"></div> </div> </div> </div> </div>`;
// Exports
export default code;